/* global Logger */
import cloudinaryText from './texts.json'

const DEFAULT_CLOUDINARY_CONFIG = {
  // https://cloudinary.com/documentation/upload_widget#upload_widget_options
  cloudName: 'meet-in-class',
  uploadPreset: 'teacher-profile',
  multiple: false,
  sources: ['local', 'url'],
  language: 'fr',
  text: cloudinaryText,
}

export function cloudinaryUploadAction (config, cb) {
  if (!window.cloudinary) {
    Logger.debug('cloudinary failed to load, prompt for reload')
    if (window.confirm('Une erreur est survenue. Veuillez recharger la page.')) {
      Logger.debug('reloading...')
      location.reload()
    } else {
      Logger.debug('Refused to reload')
    }
    return
  }
  window.cloudinary.openUploadWidget({...DEFAULT_CLOUDINARY_CONFIG, ...config}, cb)
}
